import { Button, Form } from 'antd';
import React, { useState } from 'react';
import authService from '../../services/auth.service';
import { notifyError, notifySuccess } from '../../utils/notification';
import { TAInput } from '../widgets';
import './antd.form.css';
import './user-management.css';

export const RequestPasswordResetForm: React.FC<any> = ({ onError, onSubmit, onSuccess }) => {
	const [error, setError] = useState<any>();
	const [form] = Form.useForm();

	const onFinish = async values => {
		try {
			onSubmit && onSubmit();
			let resp = await authService.requestResetPassword(values.email);
			notifySuccess('Password reset email is sent to you with reset link');
			setError(null);
			form.setFieldsValue(values);
			onSuccess && onSuccess();
		} catch (e: any) {
			setError(e.message);
			notifyError(e.message);
			onError && onError();
			return;
		}
	};

	return (
		<Form layout="vertical" className="ta-form" form={form} onFinish={onFinish}>
			<Form.Item
				label="Email"
				name="email"
				rules={[
					{ required: true, message: 'Please enter you email.' },
					{
						type: 'email',
						message: 'Not valid email'
					}
				]}
			>
				<TAInput />
			</Form.Item>

			<Form.Item>
				<Button htmlType="submit" className="ta-ant-btn">
					Save
				</Button>
			</Form.Item>
		</Form>
	);
};
